import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { PlpQtyResultsComponent } from './plp-qty-results.component';

@NgModule({
  declarations: [PlpQtyResultsComponent],
  imports: [
    CommonModule,
    I18nModule,

    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        PlpQtyResults: {
          component: PlpQtyResultsComponent,
        },
      },
    }),
  ],
})
export class PlpQtyResultsModule {}
